module.exports = __webpack_public_path__ + "media/images/podcast-6-00c18ed5a24e9a03a0ad338448bb213b.jpg";